<template>
  <div class="sign-up">
    <h3>Neuen Account anlegen</h3>
    <input type="text" v-model="email" placeholder="E-Mail"><br>
    <input type="password" v-model="password" placeholder="Passwort"><br>
    <button class="button" v-on:click="createAccount">Account anlegen</button>
  </div>
</template>
<script>
  import firebase from 'firebase'
  
  export default {
    name: 'SignUp',
    data: function(){
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      createAccount: function(){
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
          function( user ) {
            alert('Der neue Account wurde erstellt.');
          },
          function( err ) {
            alert( 'Oops ' + err.message );
          }
        )
      }
    }
    
  }
</script>
<style>
  .sign-up { margin: 0.9333333em 0 0 0; }
</style>


// WEBPACK FOOTER //
// src/components/SignUp.vue